import * as React from 'react';
import { useState } from 'react';
import './Accordion.css'; 

interface IAccordionProps {
    accordianData: Array<any>;
} 

 
const Accordion= (props: IAccordionProps) => {  
    
    const { accordianData } = props;

    const[selected, setSelected]= useState(null)

    const toggle=(i:any)=>{
        if(selected===i){
            return setSelected(null)
        }
        setSelected(i)
    }    
  
      return(
          <>
     <div className='accwrapper'>
         <div>
             {accordianData.map((item:any,i:any)=>(
             <div className='accitem'>
                 <div className='acctitle' onClick={()=>toggle(i)}>
                   <span>{item.question}</span>
                   <span className='icon-plus'>{selected===i ? '-' : '+'}</span>
                 </div>
                 <div className={
                     selected===i?'acccontent accshow' :'acccontent'
                
                 }>
                     <p  dangerouslySetInnerHTML={{ __html: item.answer }} />
                     
                 </div>
             </div>
             ))}
         </div>
     </div>
     </>
      );
   }

   
   


 
export default Accordion;




// WEBPACK FOOTER //
// ./src/components/accordion/Accordion.tsx